/**
 * Some browser privacy policies throw when the storage getter itself is read.
 * The installed Realtime/Phoenix transport reads that getter during module
 * startup, before React can render address entry. Expose an empty interface in
 * that case, while STILL rejecting writes. This is not an in-memory fallback:
 * a property lookup must never claim it can recover an entry that wasn't saved.
 */
export function guardUnavailableSessionStorage(): void {
  if (typeof window === "undefined") return;
  try {
    void window.sessionStorage;
    return;
  } catch {
    const unavailable: Storage = {
      length: 0,
      key: () => null,
      getItem: () => null,
      setItem: () => { throw new DOMException("Session storage is unavailable", "SecurityError"); },
      removeItem: () => {},
      clear: () => {},
    };
    try {
      Object.defineProperty(window, "sessionStorage", {
        configurable: true,
        get: () => unavailable,
      });
    } catch {
      // An immutable accessor must not prevent the following URL cleanup.
      // Lookup persistence still fails closed through its own storage guard.
    }
  }
}
